import React, { useEffect, useState } from "react";
import Input from "../modules/Input";
import DropBtn from "../modules/DropBtn";
import upload from "../../Assets/svg/upload-icon.svg";
import Button from "../modules/Button";
import StaticField from "../StaticField";
import { useDispatch, useSelector } from "react-redux";
import { addFieldCount, addPersonalInfo, setEmpty } from "./redux/actions";
import DocUpload from "../modules/DocUpload";
import { api } from "../../Services";
import { addTokenInfo } from "../LoginPage/redux/actions";
import { modifyPage } from "../ApplicationForm/redux/actions";
import { StateList } from "../modules/CollegeList";
import StaticItem from "../modules/StaticItem";
import GradientLoader from "../modules/Loader";
import ModalComponent from "../modules/Modal";
import TransitionAlerts from "../modules/Alerts";

function FieldSetBottom(props) {
  const personalInfo = useSelector((state) => state.personal.personalInfo);
  const status = useSelector((state) => state.status.statusData);
  const dispatch = useDispatch();
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const isEmpty = useSelector((state) => state.personal);
  const [alertType, setAlertType] = useState({ msg: "", type: "" });
  const [alert, setAlert] = useState(false);
  const [err, showErr] = useState(false);
  const [permanent, setPermanent] = useState(false);
  const docs = useSelector((state) => state.tokens.tokens.docs);
  const tokenData = useSelector((state) => state.tokens.tokens);
  const [uploading, setUploading] = useState(false);
  const [doc, setDoc] = useState(null);
  const [Addr, setAddr] = useState([
    { title: "Address Line 1", value: "address1" },
    { title: "Address Line 2", value: "address2" },
    {
      title: "State",
      value: "state",
      list: ["Karnataka", "Maharashtra", "Kerala"],
    },
    {
      title: "City",
      value: "city",
      list: ["Bengaluru", "Mumbai", "Trivendrum"],
    },
    { title: "Pin code", value: "pin" },
  ]);

  const getCityList = (value) => {
    let cityList = StateList?.filter((item) => item?.state === value)
      .map((item) => item["city"])
      ?.sort((a, b) => a?.localeCompare(b));
    setCities([...cityList]);
  };
  function validateFileName(fileName) {
    // Split the file name by '.' to get the individual parts
    let name = fileName?.name;
    const parts = name?.split(".");

    // Check if the file name contains more than one part
    if (parts?.length > 2) {
      props.showModal("File with double extensions is not allowed.");

      // alert("File with double extensions is not allowed.");
      fileName = null;
    }
    return fileName;
  }
  const filterData = (type, value) => {
    if (type === "pin") {
      if (
        personalInfo?.address.filter((a) => a?.addressType === "TEMPORARY")[0]
          ?.pin === ""
      ) {
        if (value == 0) {
          value = "";
        }
      }
      if (value?.length > 6) {
        value = value.slice(0, 6)?.replace(/\D/g, "");
      }
    } else if (type === "state") {
      getCityList(value);
    } else if (type === "addressProof") {
      const allowedTypes = [
        "application/pdf",
        "image/jpeg",
        "image/png",
        "application/msword",
        ".doc",
        ".docx",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];
      if (value) {
        let isFormat = false;
        for (let i in allowedTypes) {
          if (value.type === allowedTypes[i]) {
            isFormat = true;
          }
        }
        if (!isFormat) {
          value = null;
          props.showModal("Only PDF, JPEG, PNG, and Word files are allowed.");

          // alert("Only PDF, JPEG, PNG, and Word files are allowed.");
          //   setDoc(null); // Clear the file input
        } else if (value !== null && value.size / 1024 / 1024 > 2) {
          value = null;
          props.showModal(" File size exceeds the maximum upload size limit.");

          // alert(" File size exceeds the maximum upload size limit.");
          // showErr(true)
          // setTimeout(() => showErr(false), 3000);
        }
      }
      value = validateFileName(value);
      // return e;
    }
    return value;
  };

  const addData = (type, value) => {
    value = filterData(type, value);
    if (type === "addressProof" && value !== null) {
      if (value.size / 1024 / 1024 > 2) {
        value = null;
        showErr(true);
        // setTimeout(()=>showErr(false),3000)
      } else if (
        value?.type === "application/zip" ||
        value?.type.startsWith("video/") ||
        value?.type.startsWith("audio/")
      ) {
        props.showModal("Sorry, you cannot upload ZIP files or media files.");
        value = null; // Clear the file input
      }
    }
    setDoc(value);
    dispatch(addPersonalInfo({ type: type, value: value }));
    dispatch(modifyPage("Yes"));
  };

  const setTemporary = (type) => {
    let addrValues = ["address1", "address2", "city", "state", "pin"];
    let permData = personalInfo.address.filter(
      (a) => a.addressType === "PERMANENT"
    )[0];
    let tempData = personalInfo.address.filter(
      (a) => a.addressType === "TEMPORARY"
    )[0];
    for (let i in addrValues) {
      let data = "";
      if (type) {
        if (permData && permData[addrValues[i]]) {
          data = permData[addrValues[i]];
        }
      } else if (
        tempData &&
        tempData[addrValues[i]] !== permData[addrValues[i]]
      ) {
        data = tempData[addrValues[i]];
      }
      addData(addrValues[i], data);
    }
    // dispatch(setEmpty(!isEmpty))
    setPermanent(type);
  };

  const getDocs = async (type) => {
    const docs2 = await api.getDocuments(
      "application",
      tokenData?.applicationData.id,
      tokenData?.token
    );
    if (type && docs?.data && docs?.data[type]) {
      props.showModal("Your Document has been uploaded successfully!");
    }
    dispatch(addTokenInfo(["docs", docs2.data]));
  };
  const uploadFunction = async (data) => {
    try {
      const result = await api.uploadDocument(
        "application",
        tokenData?.applicationData.id,
        tokenData?.token,
        data
      );
      // if (result?.statusCode == 200 || result?.data?.id) {
      props.showModal("Your Document has been uploaded successfully!");
      console.log("result", result);
      setAlert(true);
      setAlertType({
        msg: "Your Document has been uploaded successfully!",
        type: "",
      });
      // }
      setUploading(false);
      getDocs(`currentAddressProof`);
      return result;
    } catch (error) {
      setUploading(false);
      props.showModal("Sorry! Something went wrong, Please try again.");

      // alert("Sorry! Something went wrong, Please try again.");
    }
  };
  const delDoc = async (type, e) => {
    addData(type, e);
    e = validateFileName(e);
    let file;
    if (docs[type]) {
      file = docs[type];
    }
    if (e) {
      try {
        setUploading(true);
        const formData = new FormData();
        formData.append("file", e);
        formData.append("name", e.name);
        formData.append("size", e.size);
        formData.append("documentType", `currentAddressProof`);
        formData.append("fileType", e.type.split("/")[1]);
        if (file) {
          formData.append("id", file.id);
        }
        const result = await uploadFunction(formData);
        if (result?.statusCode == 200) {
          props.showModal("Your Document has been uploaded successfully!");
          // setUploading(false);
        }
        // if (docs2?.data[`currentAddressProof`]) {
        //   // addData("addressProof", "data");
        // }
        setUploading(false);
        getDocs(`currentAddressProof`);
      } catch (error) {
        setUploading(false);
        getDocs();
        alert("Sorry! Something went wrong, Please try again.");

        console.error("Error uploading document:", error);
      }
    }
  };
  const handleUpload = async (e) => {
    e = validateFileName(e);
    if (e) {
      try {
        setUploading(true);
        const formData = new FormData();
        formData.append("file", e);
        formData.append("name", e.name);
        formData.append("size", e.size);
        formData.append("documentType", `currentAddressProof`);
        formData.append("fileType", e.type.split("/")[1]);
        const result = await uploadFunction(formData);
        if (result?.statusCode == 200) {
          props.showModal("Your Document has been uploaded successfully!");
        }
        setUploading(false);
        getDocs(`currentAddressProof`);
      } catch (error) {
        setUploading(false);

        alert("Sorry! Something went wrong, Please try again.");
        getDocs();

        console.error("Error uploading document:", error);
      }
    }
  };

  useEffect(() => {
    let errList = [];
    let count = 0;
    // console.log('permanent',personalInfo)
    if (permanent) {
      let items = [
        "address1",
        "address2",
        "city",
        "state",
        "pin",
        "addressProof",
      ];
      for (let i in items) {
        let data = personalInfo?.address?.filter(
          (a) => a?.addressType === "TEMPORARY"
        )[0];
        if (data) {
          let newItem = items[i];
          if (!data[newItem]) {
            count += 1;
            errList = [...errList, items[i]];
            // console.log('is empty',errList)
          }
        }
      }
    }
    // let doc=personalInfo.address.filter((a) => a.addressType === "TEMPORARY")[0]["addressProof"]
    // if(doc.size/1024/1024 >2){
    //   console.log('err',doc.size/1024/1024)
    // }
    dispatch(addFieldCount({ field2: errList?.length }));
    // props.onChange("field2",errList.length)
  }, [personalInfo, permanent]);

  useEffect(() => {
    let temp = personalInfo?.address?.filter(
      (a) => a?.addressType === "TEMPORARY"
    )[0];
    let permanentAddr = personalInfo?.address?.filter(
      (a) => a?.addressType === "PERMANENT"
    )[0];
    let perm = false;
    if (temp) {
      if (temp?.address1 === "" || temp?.address1 === permanentAddr.address1) {
        // setTemporary();
        perm = true;
      }
    } else {
      perm = true;
    }
    setTemporary(perm);
    // setPermanent(perm);

    let data = StateList?.map((item) => item["state"])?.sort((a, b) =>
      a.localeCompare(b)
    );
    if (temp?.state) {
      getCityList(temp?.state);
    }
    setStates([...new Set(data)]);
  }, []);
  useEffect(() => {
    
  if(docs && docs[`currentAddressProof`] ){
    console.log('doc changed',docs )
  }
   
  }, [docs]);
  return (
    <div className="field-set set-three">
      <div className="set-left set">
        <div className="field">
          <div className="set-title">Permanent Address</div>
          <div className="set-sub-title">
            Details are captured from Aadhar Card
          </div>
          {Addr?.map((item, index) => {
            // console.log('in loop',personalInfo.address, personalInfo.address.filter(a=>a.addressType ==="PERMANENT"))
            return (
              <StaticField
                key={index}
                showTick={true}
                title={item?.title}
                value={
                  personalInfo.address.filter(
                    (a) => a?.addressType === "PERMANENT"
                  )[0]
                    ? personalInfo.address.filter(
                        (a) => a?.addressType === "PERMANENT"
                      )[0][item?.value]
                    : item?.title
                }
              />
            );
          })}
        </div>{" "}
      </div>
      <div className="set-right set">
        <div className="field">
          <div className="set-title">Current Address</div>
          <div className="set-sub-title">
            This will where your family/guardian currently resides.
          </div>
          <div className="check-permanent">
            <input
              className="custom-checkbox"
              checked={permanent}
              type="checkbox"
              onChange={() => setTemporary(!permanent)}
            />
            Same as Permanent Address
          </div>
          {permanent
            ? Addr?.map((item, index) => {
                return (
                  <StaticField
                    key={index}
                    showTick={false}
                    title={item?.title}
                    value={
                      personalInfo?.address.filter(
                        (a) => a?.addressType === "TEMPORARY"
                      )[0]
                        ? personalInfo?.address.filter(
                            (a) => a?.addressType === "TEMPORARY"
                          )[0][item?.value]
                        : item?.title
                    }
                  />
                  
                );
              })
            : Addr?.map((item, index) => {
              // console.log('item?.title',item?.title);
                if (item?.title === "City" || item?.title === "State") {
                  return (<>
                    <DropBtn
                      key={index}
                      onChange={(e) => addData(item?.value, e)}
                      title={item?.title}
                      value={
                        personalInfo?.address.filter(
                          (a) => a?.addressType === "TEMPORARY"
                        )[0]
                          ? personalInfo?.address.filter(
                              (a) => a?.addressType === "TEMPORARY"
                            )[0][item?.value]
                          : ""
                      }
                      list={item?.title === "State" ? states : cities}
                    />
                    {((status?.personalList?.rest?.includes('state') && item.title === 'State') ||(status?.personalList?.rest?.includes('city') && item.title === 'City') ) && (
                    <p style={{color: "#f64c4c", marginBottom:'3%'}} className="set-sub-title">
                      Required
                    </p>
                  )}
                    </>
                  );
                } else {
                  return (
                    <>
                    <Input
                      key={index}
                      id={item?.value === "pin" ? "pinCode" : ""}
                      placeholder={item?.title}
                      onChange={(e) => addData(item?.value, e)}
                      value={
                        personalInfo?.address.filter(
                          (a) => a?.addressType === "TEMPORARY"
                        )[0]
                          ? personalInfo?.address?.filter(
                              (a) => a?.addressType === "TEMPORARY"
                            )[0][item?.value]
                          : ""
                      }
                    />
                   {(status?.personalList?.rest?.includes("address1" ) ||status?.personalList?.rest?.includes("address2") )  &&
                      <p style={{color: "#f64c4c", marginBottom:'3%'}} className="set-sub-title">Required</p>}
                      </>);
                }
                
              })}
            
          {!permanent && (
            <div
              className={`field-row upload  ${
                docs && docs[`currentAddressProof`] && "doc-col"
              }`}
            >
              {docs && docs[`currentAddressProof`] ? (
                <div className="doc-item">
                  <StaticItem
                    onDelete={(e) => delDoc(`currentAddressProof`, e)}
                    type={"doc"}
                    doc={docs[`currentAddressProof`]}
                    isEditable={true}
                    title={"Current Address Proof"}
                    docUrl={docs[`currentAddressProof`]?.documentUrl}
                    value={docs[`currentAddressProof`]?.name}
                    size={Math.floor(docs[`currentAddressProof`]?.size / 1024)}
                  />
                </div>
              ) : (
                <div className="file-upload-container">
                  <DocUpload
                    title={"Current Address Proof"}
                    noTooltip={true}
                    value={doc?.name ? doc : null}
                    onChange={(e) => handleUpload(e)}
                  />
                  {/* {doc?.name && (
                    <Button
                      className="upload-button"
                      onClickHandler={() => handleUpload()}
                      disabled={uploading}
                      value={
                        uploading ? <span className="spinner"></span> : "Upload"
                      }
                      type={"contained"}
                    />
                  )} */}
                
                </div>
              )}
              {(err || status?.personalList?.rest?.includes("addressProof")) && (
                <p className="set-sub-title" style={{color: "#f64c4c", marginBottom:'3%'}}>
                 {status?.personalList?.rest?.includes("addressProof") ? 'Required' : "File size exceeds the maximum upload size limit."}
                </p>
              )}
            </div>
          )}
        </div>
      </div>
      {alertType.msg && (
        <TransitionAlerts isAlert={alert} message={alertType.msg} />
      )}
      {uploading && (
        <ModalComponent
          className={"loader-model"}
          show={uploading}
          // handleClose={() => CancelData()}
          // title={ModalData.title}
          // content={ModalData.desc}
        >
          <GradientLoader />
        </ModalComponent>
      )}
    </div>
  );
}

export default FieldSetBottom;
